import React, { useState, useRef } from 'react'
import { Button, Badge, Box, Stack, Text, Alert, SimpleModal, SimpleTable } from '@/components/lib'
import utils from '@/utils/utils'

function CSVChooser ({ trigger, title, instructions, sample, formatFunction, onComplete }) {
  const [open, setOpen] = useState(false)
  const [header, setHeader] = useState([])
  const [rows, setRows] = useState()
  const inputRef = useRef()

  function handleFileChosen (event) {
    const file = event.target.files?.[0]
    if (!file) { return }
    const reader = new window.FileReader()
    reader.addEventListener('load', (event) => {
      const text = event.target.result
      const [h, r] = formatFunction(text)
      setHeader(h)
      setRows(r)
    })
    reader.readAsText(file)
  }

  function downloadSample () {
    const url = `data:text/csv;charset=utf-8,${encodeURIComponent(sample.headings.join(',') + '\n' + sample.rows.map(r => r.join(',')).join('\n'))}`
    utils.downloadFile(url, sample.filename || 'sample.csv')
  }

  return (
    <>
      {trigger
        ? React.cloneElement(trigger, { onClick: () => setOpen(true) })
        : <Button colorPalette='blue' onClick={() => setOpen(true)}>Upload a CSV file</Button>}
      <SimpleModal
        isOpen={open} onClose={() => setOpen(false)} modalProps={{ size: '3xl' }}
        header={title || 'Upload a CSV'}
        body={
          <Stack gap={5}>
            {instructions && <Text fontSize='md'>{instructions}</Text>}
            {sample &&
              <Button variant='link' onClick={downloadSample}>Download sample CSV file</Button>}
            <input type='file' style={{ display: 'none' }} ref={inputRef} onChange={handleFileChosen} accept='.csv' />
            <Button onClick={() => inputRef.current.click()} colorPalette='primary'>Choose a file</Button>
            {rows?.length > 0 &&
              <Stack gap={5}>
                <Text fontWeight='bold'>Ready to import the following {rows?.filter(r => !r.error).length} rows?</Text>
                {rows?.filter(r => r.error).length > 0 &&
                  <Alert size='sm' variant='left-accent' status='warning'>Some rows have errors and will be ignored. To remove the errors please check the table below and adjust your CSV file accordingly.</Alert>}

                <Box h={300} overflowY='auto'>
                  <SimpleTable
                    headers={[...header, 'Status']}
                    rows={rows.map(row =>
                      [...header.map(h => row[h]), row.error ? <Badge colorPalette='orange'>{row.error}</Badge> : <Badge colorPalette='green'>Ready</Badge>]
                    )}
                  />
                </Box>
              </Stack>}
          </Stack>
}
        footer={
          <>
            <Button variant='ghost' mr={3} onClick={() => setOpen(false)}>Cancel</Button>
            {rows?.length > 0 &&
              <Button colorPalette='primary' onClick={() => { setOpen(false); onComplete(rows) }}>Import {rows?.filter(r => !r.error).length} rows</Button>}
          </>
}
      />
    </>
  )
}

export default CSVChooser
